const positionRouter = [
    {
        path: "list-position",
        name: "position",
        component: () => import("@/views/admin/position"),
        default: true,
        meta: {
            model: "position",
            // requiresAuth: true,
        },
    },
    {
        path: "list-position/add",
        name: "addPosition",
        component: () => import("@/views/admin/position/function"),
        default: true,
        meta: {
            model: "position",
            // requiresAuth: true,
        },
    },
    {
        path: "list-position/edit/:id",
        name: "editPosition",
        component: () => import("@/views/admin/position/function"),
        default: true,
        meta: {
            model: "position",
            // requiresAuth: true,
        },
    }
]
export default positionRouter;